'use client';
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Box, Button, Stack, Text, Textarea } from '@/components';
import {
  useInputAttributes,
  useProfile,
  useSendCommentNew,
  useTranslation,
} from '@/hooks';
import { yupValidator } from '@/utils';

const SendComment: React.FC<{ comment: boolean; newsId: string }> = ({
  comment,
  newsId,
}) => {
  const { t } = useTranslation('pages.blog');
  const { mutateAsync: sendComment, isPending } = useSendCommentNew();

  const { data: profile } = useProfile();
  const validationSchema = yupValidator.object().shape({
    comment: yupValidator
      .string()
      .max(500)
      .label(t('registerComment'))
      .required(),
  });

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    resetField,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const filedInputProps = useInputAttributes(control, register, errors, {
    comment: comment ? t('textMessage') : t('beTheFirstToPostComment'),
  });

  const sendForm = async (data: { comment: string }) => {
    await sendComment({ news_id: newsId, content: data.comment });
    resetField('comment');
  };

  if (!profile) {
    return <Text>{t('toSendCommentPleaseLogin')}</Text>;
  }

  return (
    <Box>
      <Textarea bg="gray.250" {...filedInputProps.comment} mt="5px" />
      <Stack mt="2" direction="row" justify="flex-end">
        <Button
          isLoading={isPending}
          colorScheme="primary"
          size="md"
          onClick={(data) => void handleSubmit(sendForm)(data)}
        >
          {t('send')}
        </Button>
      </Stack>
    </Box>
  );
};
export default SendComment;
